var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-button',{attrs:{"icon":"mail","label":"Email"},on:{"click":_vm.setEmail}})
}
var staticRenderFns = []

export { render, staticRenderFns }